// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropdown from '@localytics/loc-components/lib/Dropdown';
import Button from '@localytics/loc-components/lib/Button';
import './ChooseAppGroupPage.scss';
import { chooseAppGroup } from './actions/wip';

type Option = {
  label: string,
  value: number
};

type Props = {
  appGroups: Array<Object>,
  orchestrationName: string,
  dispatch: Function,
  switchPage: Function
};

type State = {
  selectedValue: Option | null
};

class ChooseAppGroupPage extends Component<Props, State> {
  state = { selectedValue: null };

  componentDidMount: Function = () => {
    const { dropdown } = this;
    if (dropdown) {
      dropdown.getElementsByClassName('Select-input')[0].focus();
    }
  };

  componentDidUpdate: Function = (prevProps, prevState) => {
    const { button } = this;
    const { selectedValue: currentValue } = this.state;
    const { selectedValue: prevValue } = prevState;
    if (button && currentValue !== prevValue) {
      button.getElementsByTagName('button')[0].focus();
    }
  };

  setValue: Function = (option: { label: string, value: number }) => {
    this.setState({ selectedValue: option });
  };

  button: ?HTMLDivElement;
  dropdown: ?HTMLDivElement;

  submitValue: Function = () => {
    const { selectedValue } = this.state;

    // This makes flow happy :/ but the submit isn't allowed until a value is selected
    if (!selectedValue) {
      return;
    }

    this.props.dispatch(chooseAppGroup(selectedValue.value));
    this.props.switchPage('chooseEntryEvent');
  };

  render() {
    const { appGroups, orchestrationName } = this.props;

    let isLoading = false;
    let options = [];
    if (appGroups) {
      options = appGroups
        .map(group => ({
          label: group.name,
          value: group.id
        }))
        .sort((optionA, optionB) => optionA.label.localeCompare(optionB.label));
    } else {
      isLoading = true;
    }

    return (
      <div className="Page__Body" style={{ backgroundColor: 'white' }}>
        <div className="Page__Header">
          <div className="Page__Header__Title">{orchestrationName}</div>
        </div>
        <div
          className="Page__Content Page__Content--flexible"
          style={{ paddingBottom: '150px' }}
        >
          <div className="ChooseAppGroupPage">
            <h1>Select an audience</h1>
            <div className="ChooseAppGroupPage__Body">
              <p>Choose the app group you would like to target</p>
              <div
                className="ChooseAppGroupPage__Dropdown"
                ref={dropdown => {
                  this.dropdown = dropdown;
                }}
              >
                <Dropdown
                  name="AppGroup"
                  options={options}
                  selectedValue={this.state.selectedValue}
                  onSelect={this.setValue}
                  clearable={false}
                  onSubmit={this.submitValue}
                  isLoading={isLoading}
                />
              </div>
              <div
                className="ChooseAppGroupPage__Button"
                ref={div => {
                  this.button = div;
                }}
              >
                <Button
                  type="primary"
                  label="Confirm Audience"
                  onClick={this.submitValue}
                  disabled={!this.state.selectedValue}
                />
              </div>
            </div>
            {this.state.selectedValue && (
              <span className="ChooseAppGroupPage__EnterToContinue">
                Hit <span>↵ Enter</span> to continue
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  orchestrationName: state.wip.orchestrationName,
  appGroups: state.railsApi.appGroups
});
export default connect(mapStateToProps)(ChooseAppGroupPage);



// WEBPACK FOOTER //
// ./src/ChooseAppGroupPage.jsx